export const createReport = async ({body, token}) => {
    const headers = { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' }
    const response = await fetch('https://makegayfriends.com/api/v1/reports', { method:"POST", headers, body:JSON.stringify(body) });
    const data = await response.json();
    return data
}